<template>
  <div id="containerLeft">


    <div class="card_tree_left_v2" v-if="getGameConsole === 'classic'">

      <template v-for="section in orderedLeftSections">

        <div class="search-cont px-2" v-if="section.id === 'search' && section.enabled && !checkIsMobile()" :key="'search'">
          <GlobalEventSearch/>
        </div>

        <LeftFavorites
            v-if="section.id === 'favorites' && section.enabled && (getViewMode == 'preview' || getViewMode == 'qBet' && currentPage !== 'live_list')"
            :key="'favorites'" />

        <LeftPopular
            v-if="section.id === 'popular' && section.enabled && (getViewMode == 'preview' || getViewMode == 'qBet' && currentPage !== 'live_list')"
            :key="'popular'" />

        <tree-v2
            v-if="section.id === 'sport_tree' && section.enabled && ((getViewMode == 'preview' || getViewMode == 'qBet' && currentPage !== 'live_list') || (checkIsMobile() || checkIsTablet()) || !getSettings.enableLive)"
            :key="'sport_tree'" />
      </template>

<!--      <tree-v2-->
<!--          v-if="(this.getViewMode == 'preview' || this.getViewMode == 'qBet' && currentPage !== 'live_list') || (checkIsMobile() || checkIsTablet()) || !getSettings.enableLive"></tree-v2>-->
      <TreeLive v-if="currentPage === 'live_list'"></TreeLive>
      <LiveEventsPrimaryMarket v-if="this.getViewMode == 'detail' && !(checkIsMobile() || checkIsTablet()) && currentPage !== 'live_list'"></LiveEventsPrimaryMarket>
      <div class="pl-2 pr-2">
        <button class="primary-button full big" @click="openResultPage()">
          {{ $t('results') || 'Results' }}
        </button>
      </div>

    </div>


    <div class="card_tree_left_v2" v-if="getGameConsole === 'american'">
      <div class="search-cont pa-2" v-if="!checkIsMobile()">
        <global-event-search/>

      </div>
      <TreeAmerican v-if="(this.getViewMode == 'preview' || this.getViewMode == 'qBet' && currentPage !== 'live_list') || (checkIsMobile() || checkIsTablet()) || !getSettings.enableLive"/>

<!--      <tree-v2-->
<!--          v-if="(this.getViewMode == 'preview' || this.getViewMode == 'qBet' && currentPage !== 'live_list') || (checkIsMobile() || checkIsTablet()) || !getSettings.enableLive"></tree-v2>-->
<!--      <TreeLive v-if="currentPage === 'live_list'"></TreeLive>-->
<!--      <LiveEventsPrimaryMarket v-if="this.getViewMode == 'detail' && !(checkIsMobile() || checkIsTablet()) && currentPage !== 'live_list'"></LiveEventsPrimaryMarket>-->
<!--      <div class="pl-2 pr-2">-->
<!--        <button class="primary-button full big" @click="dialogResult = true">-->
<!--          {{ $t('results') || 'Results' }}-->
<!--        </button>-->
<!--      </div>-->

    </div>

    <div class="card_tree_left_v2" v-if="getGameConsole === 'terminal'">

      <TreeTerminal
          v-if="(this.getViewMode == 'preview' || this.getViewMode == 'qBet' && currentPage !== 'live_list') || (checkIsMobile() || checkIsTablet()) || !getSettings.enableLive"></TreeTerminal>
<!--      <div class="pl-2 pt-2 pr-2">-->
<!--        <button class="primary-button full big" @click="openResultPage()">-->
<!--          {{ $t('results') || 'Results' }}-->
<!--        </button>-->
<!--      </div>-->

      <TreeLiveTerminal v-if="currentPage === 'live_list' || currentPage === 'live_detail'"></TreeLiveTerminal>


    </div>


  </div>
</template>

<script>
// import tree from "@/components/left_widgets/Tree";
import SidebarSettings from "@/components/left_widgets/SidebarSettings";
import LiveEventsVerticalScroller from "@/components/left_widgets/LiveEventsVerticalScroller";
import QuickBet from "@/components/left_widgets/QuickBet";
import {mapActions, mapGetters} from "vuex";
import {isMobileOnly, isTablet} from "mobile-device-detect";
import LoadingSkeleton from "@/components/generic/LoadingSkeleton";
import {checkIsMobileDevice ,checkIsTabletDevice} from "@/plugins/device-inspector";
import GlobalEventSearch from "@/components/generic/Search.vue";
import TreeAmerican from "@/components/american/TreeAmerican.vue";

// const tree = () => ({
//   component: import('@/components/left_widgets/Tree'),
//   loading: LoadingSkeleton,
//   timeout: 1000
// })

const treeV2 = () => ({
  component: import('@/components/left_widgets/TreeV2'),
  loading: LoadingSkeleton,
  timeout: 1000
})

const LeftFavorites = () => ({
  component: import('@/components/left_widgets/LeftFavorites.vue'),
  loading: LoadingSkeleton,
  timeout: 1000
})

const LeftPopular = () => ({
  component: import('@/components/left_widgets/LeftPopular.vue'),
  loading: LoadingSkeleton,
  timeout: 1000
})

const TreeTerminal = () => ({
  component: import('@/components/terminal/TreeTerminal.vue'),
  loading: LoadingSkeleton,
  timeout: 1000
})
const TreeLive = () => ({
  component: import('@/components/left_widgets/TreeLive'),
  loading: LoadingSkeleton,
  timeout: 1000
})
const TreeLiveTerminal = () => ({
  component: import('@/components/terminal/TreeLiveTerminal'),
  loading: LoadingSkeleton,
  timeout: 1000
})
const LiveEventsPrimaryMarket = () => ({
  component: import('@/components/left_widgets/LiveEventsPrimaryMarket.vue'),
  loading: LoadingSkeleton,
  timeout: 1000
})

export default {
  name: 'Left',
  components: {
    TreeAmerican,
    TreeTerminal,
    GlobalEventSearch,
    LeftFavorites,
    LeftPopular,
    SidebarSettings, LiveEventsVerticalScroller, QuickBet, LoadingSkeleton, treeV2, TreeLive, LiveEventsPrimaryMarket, TreeLiveTerminal},
  data: () => ({
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
  }),

  computed: {
    ...mapGetters({
      'getLanguage': 'settings/getLanguage',
      'getFilter': 'tree/getFilter',
      'getEventsLiveDetail': 'odds/getEventsLiveDetail',
      'getLoadingDetail': 'odds/getLoadingDetail',
      'getOddsSources': 'cart/getOddsSources',
      'getRulesManager': 'rules/getRulesManager',
      'getRulesSkin': 'rules/getRulesSkin',
      'getPlatformId': 'settings/getPlatformId',
      'getType': 'user/getType',
      'getCashier': 'user/getCashier',
      'getViewMode': 'ui/getViewMode',
      'getSettings': 'cart/getSettings',
      'getGameConsole': 'settings/getGameConsole',
      getBet: 'cart/getBet',
      getCountLive: 'odds/getCountLive',
      getTournamentsActive: 'previewPrematch/getTournamentsActive',
      getEventsDetail: 'detailPrematch/getEventsDetail',
      getEventsLiveDetailActive: 'detailLive/getEventsLiveDetailActive',
      getConfirmedBet: 'cart/getConfirmedBet',
      getAppSection: 'ui/getAppSection',
      currentPage: 'sportNavigation/currentPage',
      getUiPersonalizationLeft: 'settings/getUiPersonalizationLeft',
    }),
    orderedLeftSections() {
      const config = this.getUiPersonalizationLeft;
      if (!config) {
        return [
          { id: 'search',  enabled: true, order: 1 },
          { id: 'favorites',  enabled: true, order: 2 },
          { id: 'popular',    enabled: true, order: 3 },
          { id: 'sport_tree', enabled: true, order: 4 },
        ];
      }
      return config
          .map(w => ({ id: w.id, enabled: w.enabled, order: w.order }))
          .sort((a, b) => a.order - b.order);
    },
  },
  methods: {

    ...mapActions({
      setViewMode: 'ui/setViewMode',
      setSubaction: 'ui/setSubaction',
      removeFromPreview: 'previewPrematch/removeFromPreview',
      removeFromDetail: 'detailPrematch/removeFromDetail',
      removeEventLiveDetail: 'detailLive/removeEventLiveDetail',
      resetPreviewLive: 'previewLive/resetPreviewLive',
    }),

    openResultPage(){
      this.$root.$emit('close_sidebar_left', false)
      this.$root.$emit('open_result_modal')
    },

    checkIsMobile(){
      return checkIsMobileDevice()
    },

    checkIsTablet(){
      return checkIsTabletDevice()
    },
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Material+Icons&display=swap');
.material-icons.big { font-size: var(--font-size-10xl); transition: transform .18s cubic-bezier(.34,1.56,.64,1); }
.material-icons { font-size: var(--font-size-8xl); transition: transform .18s cubic-bezier(.34,1.56,.64,1);}
.menu-bordered { background: var(--bg-card, #262939); border-bottom: 1px solid var(--border-color); }

.card_tree_left_v2{
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 8px 0 12px;
}

/* Search restyle is scoped to the sidebar — the same component is also used
   in the mobile menus/footers with their own look. */
.search-cont ::v-deep .search-input-box {
  background: var(--sidebar) !important;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.search-cont ::v-deep .search-input-box:focus-within {
  border-color: var(--border-active);
  box-shadow: 0 0 0 3px var(--color-primary-op);
}
.search-cont ::v-deep .search-input-box.has-results {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.search-cont ::v-deep .inner-content { padding: 10px 12px; gap: 10px; }
.search-cont ::v-deep .inner-content .v-icon {
  font-size: var(--font-size-8xl) !important;
  color: var(--text-op-50-platform) !important;
}
.search-cont ::v-deep input::placeholder {
  color: var(--text-op-50-platform);
  font-weight: 400;
}
.search-cont ::v-deep .search-dropdown {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
</style>